import { vizag2026 } from "../data/vizag2026"

// Frame the artwork inside the supplied square PNG, which includes wide white margins.
// The original asset is preserved; only its display area is cropped.
export function VizagLogo({ className = "" }) {
  return (
    <span className={`relative block shrink-0 overflow-hidden rounded-xl ${className}`} style={{ aspectRatio: "2025 / 1395" }}>
      <img
        src={vizag2026.logo}
        alt="CTS 2026 Vizag Edition"
        className="absolute h-auto max-w-none"
        style={{ width: "106.617%", left: "-2.272%", top: "-28.53%" }}
      />
    </span>
  )
}
